import React, {
  useEffect, useState, useRef
} from 'react';
import KioskPaymentScreens from '@components/kioskPaymentScreens';
import NumberKeyboard from '@components/common/formElements/SimpleKeyboard/numberKeyboard';
import Modal from '@components/common/Modal';
import Loader from '@components/common/Loader';
import style from './kioskPaymentScreens.module.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
 sendChecks, updateChecksAfterResponse
} from '@reducers/storeChecks';
import { setIsAssisstance } from '@reducers/checks';
import {
  setPaymentCheck, clearCart, removeSeat, enableStartOverBtn,
  disableFooter, updateSeatInfo, checkVoid
} from '@reducers/orders';
import {
  setInActivityStatus, setOpen, setScreenSaverStatus
} from '@reducers/oauth';
import {
  paymentCash, setAuthResponse, paymentAuthError,
  paymentInitialization, receiptSms, receiptEmail,
  paymentSignature, paymentSale, clearAuthResponse,
  ingenicoPayment
} from '@reducers/payment';
import { submitSurvey, getSurvey } from '@reducers/survey';
import { setNotification } from '@reducers/notification';
import { getObjectValue } from '@utility/utills';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import EventEmitter from '@utility/eventSubscribers';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';

const KioskPayment = (props) => {

  // Props Destructuring

  const {kioskTile, paymentCheck, countrycode, auth, deviceInfo, enableStartOverBtn, setInActivityStatus, removeSeat, clearCart, setIsAssisstance,
  setOpen, check, getSurvey, paymentCash, setPaymentCheck, setAuthResponse, setNotification, disableFooter, paymentAuthError, clearAuthResponse,
  paymentSale, updateSeatInfo, ingenicoPayment, paymentInitialization, checkVoid, authResponse, receiptSms, receiptEmail, sendChecks, updateChecksAfterResponse,
  isHeight, inActivityStatus, surveyData, themeProperties  } = props;

  // State Management

  const qrTimerId = useRef(null);
  const payType = new URLSearchParams(window.location.search).get('type');
  const [cancelOrderPopUp, setCancelOrderPopUp] = useState(false);
  const [showPayment, setShowPayment] = useState({
    hideBtn: false,
    showPay: false,
    showReceipt: false,
    showTips: payType !== 'scan',
    showReceiptCard: false,
    isNumberKeyboardOpen: false,
    showReceiptType: false
  });
  const [counter, setCounter] = useState(120);
  const [tileImage, setTileImage] = useState(getObjectValue(() => kioskTile.filter((e) => e.tileTarget.paymentPage), []));
  const [isHideContinueBtn, isSetHideContinueBtn] = useState(false);
  const [paymentType, setPaymentType] = useState(payType === 'payatcounter' ? 9 : 8);
  const [tableData, setTableData] = useState(paymentCheck);
  const [keyboardValue, setKeyboardValue] = useState('');
  const [receiptType, setReceiptType] = useState({});
  const [showRetryMessage, setShowRetryMessage] = useState(false);
  const [phoneNumberMaxLength, setPhoneNumberMaxLength] = useState(getObjectValue(() => COUNTRY_CODE[auth.country].maxLength, 15));
  const isTipRequried = getObjectValue(() => auth.tipInfo.requireTipSelection, false);
  const [active, setActive] = useState(activeTip);
  const [count, setCount] = useState(60);
  const timerId = useRef(null);
  const [tipAmount, setTipAmount] = useState(auth.tipInfo && auth.tipInfo.ruleType === 1 ? ((getTotalAmountForTip() * activeTip) / 100).toFixed(2) : +(Number(activeTip)).toFixed(2));
  const [errorMessage, setErrorMessage] = useState('');
  const defaultCountryCode = countrycode || getObjectValue(() => COUNTRY_CODE[auth.country].dialCode, '1');
  const supportsSurvey = getObjectValue(() => deviceInfo.deviceGroup.brandSurveyId, false);
  const [countryCode, setCountryCode] = useState(defaultCountryCode);
  const supportsTips = getObjectValue(() => auth.tipInfo.tips.length > 0, false);
  const tipsList = supportsTips ? [...storeTips, { id: 4, key: `${LABEL().KIOSK_CUSTOM_AMOUNT} ${LABEL().CURRENCY_SYMBOL}`, displayKey: `${LABEL().KIOSK_CUSTOM_AMOUNT} ${LABEL().CURRENCY_SYMBOL}` }, { id: 5, key: `${LABEL().KIOSK_CUSTOM_PERCENT} %`, displayKey: `${LABEL().KIOSK_CUSTOM_PERCENT} %` }] : [];

  // React Hooks

  useEffect(() => {
    enableStartOverBtn(true);
    if (timerId.current) {
      clearInterval(timerId.current);
    }
    if (qrTimerId.current) {
      clearInterval(qrTimerId.current);
    }
    if(paymentType === 9){
      setShowPayment({
        showTips: false,
        showReceiptCard: true,
        showPay: false,
        hideBtn: false,
        showReceipt: false,
        showInitial: false,
        qrConfirm: false,
        showpayatcounter: true
      })
    }
  }, []);

  useEffect(() => {
    if (!getObjectValue(() => deviceGroup.brandTipId, false) || !supportsTips || payType === 'scan') {
      setPaymentType(9);
      enableStartOverBtn(false);
      setShowPayment({
        showTips: false,
        showReceiptCard: true,
        showPay: false,
        hideBtn: false,
        showReceipt: false,
        qrConfirm: false
      });
      if (payType === 'scan' || payType === 'payatcounter' || (payType === 'all' && getObjectValue(() => deviceInfo.deviceGroup.paymentTypes.scanToPay, false))) {
        handleTypes();
      } else {
        returnCreditCardMethod();
      }
    }
    if (window.ReactNativeWebView) {
    }
    setScreenSaverStatus(false);
    return () => {
      if (window.ReactNativeWebView) {
      }
      setScreenSaverStatus(false);
      if (timerId.current) {
        clearInterval(timerId.current);
      }
    };
  }, []);

  // Methods

  const storeTips = auth.tipInfo ? auth.tipInfo.tips.map((item, index) => {
    return auth.tipInfo.ruleType === 1 ? {
      ...item,
      id: index + 1,
      key: item.value * 100,
      displayKey: `${(item.value * 100).toFixed(2)} %`,
      ruleType: auth.tipInfo.ruleType
    } : {
      ...item,
      id: index + 1,
      key: item.value,
      displayKey: `${LABEL().CURRENCY_SYMBOL}${Number(item.value).toFixed(2)}`,
      ruleType: auth.tipInfo.ruleType
    };
  }) : [];

  const activeTip = getObjectValue(() => storeTips.find((item) => item.isDefault).key, 0);
  
  const getTotalAmountForTip = () => {
    let Amount = getObjectValue(() => tableData.subTotalAmount, 0);
    if (getObjectValue(() => auth.tipInfo.suggestedTipIncludesTax, false)) {
      Amount += tableData.taxAmount;
    }
    if (getObjectValue(() => auth.tipInfo.suggestedTipExcludesDiscount, false)) {
      Amount -= tableData.discountAmount;
    }
    return Number(Amount);
  };

  const handleTip = (item, value) => {
    const totalAmount = getTotalAmountForTip();
    setActive(item);
    if (getObjectValue(() => item === storeTips[0].key, false)) {
      const tipamt = auth.tipInfo.ruleType === 1 ? ((totalAmount * storeTips[0].key) / 100).toFixed(2) : +(storeTips[0].key).toFixed(2);
      setTipAmount(tipamt);
    } else if (getObjectValue(() => item === storeTips[1].key, false)) {
      const tipamt = auth.tipInfo.ruleType === 1 ? ((totalAmount * storeTips[1].key) / 100).toFixed(2) : +(storeTips[1].key).toFixed(2);
      setTipAmount(tipamt);
    } else if (getObjectValue(() => item === storeTips[2].key, false)) {
      const tipamt = auth.tipInfo.ruleType === 1 ? ((totalAmount * storeTips[2].key) / 100).toFixed(2) : +(storeTips[2].key).toFixed(2);
      setTipAmount(tipamt);
    } else if (item === `${LABEL().KIOSK_CUSTOM_AMOUNT} ${LABEL().CURRENCY_SYMBOL}`) {
      const tipamt = value && value.length > 0 && Number(value) > 0 ? Number(value).toFixed(2) : 0;
      setShowPayment({ ...showPayment, isNumberKeyboardOpen: true });
      setTipAmount(tipamt);
    } else if (item === `${LABEL().KIOSK_CUSTOM_PERCENT} %`) {
      setShowPayment({ ...showPayment, isNumberKeyboardOpen: true });
      const tipamt = value && value.length > 0 && Number(value) > 0 ? ((totalAmount * Number(value)) / 100).toFixed(2) : 0;
      setTipAmount(tipamt);
    } else {
      setTipAmount('0.00');
    }
  };

  const handleButtonClick = (item, value) => {
    setActive(item);
    switch (paymentType) {
      case 8: handleTip(item, value); break;
      default: break;
    }
  };

  const handleSurveySubmit = () => {
    setPaymentType(9);
    setShowPayment({
      showTips: false,
      showReceiptCard: true,
      showPay: false,
      hideBtn: false,
      showReceipt: true,
      showSurvey: false
    });
  };

  const handleCountryCodeChange = (event) => {
    setPhoneNumberMaxLength(Number(event.id) !== 1 ? 15 : 10);
    setCountryCode(event.id);
  };

  const goToReceipt = () => {
    setShowPayment({ showPay: false, hideBtn: false, showReceipt: true });
  };

  const goToOrder = () => {
    if (paymentType !== 5) {
      props.history.replace(`${APP_CONFIG.BASE_URL}/orders`);
    } else {
      removeSeat();
      clearCart();
      props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/landing`);
    }
  };

  const goToLandingPage = () => {
    removeSeat();
    clearCart();
    setIsAssisstance(false);
    setOpen(false);
    window.sessionStorage.removeItem('isAssisstanceCalled');
    props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/landing`);
  };

  const startTimer = (paymtType) => {
    let val = 60;
    if (timerId.current) {
      clearInterval(timerId.current);
    }
    timerId.current = setInterval(() => {
      if (val > 0) {
        val -= 1;
        setCount(val);
      } else if (val === 0 && window.location.pathname.includes('/kiosk/pay') && paymtType === 5) {
        clearInterval(timerId.current);
        goToLandingPage();
      } else {
        clearInterval(timerId.current);
      }
    }, 1000);
  };

  const getItems = () => {
    const itemArray = [];
    check.items.forEach((item) => {
      itemArray.push({
        quantity: item.quantity,
        menuItemId: item.menuItemId,
        modifiers: item.modifiers
      });
    });
    return itemArray;
  };

  const getSurveyResponse = () => {
    const orders = getItems();
    const dataToSend = {
      storeId: deviceInfo.storeId,
      deviceId: deviceInfo.deviceId,
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      items: orders,
      subTotalAmount:  tableData.subTotalAmount,
      taxAmount: tableData.taxAmount || 0.00,
      ticketId: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse'))?.ticket?.id, null),
      tipAmount: tipAmount,
      totalAmount: getTotalAmountForTip()
    };
    getSurvey(dataToSend).catch(() => {
      setPaymentType(9);
    });
  };

  const handleCashPayment = () => {
    const dataToSend = {
      storeId: deviceInfo.storeId,
      deviceId: deviceInfo.deviceId,
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      checkHeaderId: tableData.id,
      employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
      paymentStageId: getObjectValue(() => paymentCheck.paymentStageId, null),
      subTotalAmount: tableData.subTotalAmount,
      taxAmount: tableData.taxAmount || 0.00,
      seatIds: [],
      serviceChargeAmount: tableData.serviceChargeAmount || 0.00,
      discountAmount: tableData.discountAmount || 0.00,
      ticketSplitTypeId: 3,
      sendOrder: true
    };
    paymentCash(dataToSend).then((res) => {
      const discount = getObjectValue(() => res.checkHeader.discountAmount, 0);
      const serviceCharge = getObjectValue(() => res.checkHeader.serviceChargeAmount, 0);
      const updatedResponse = auth.country === 1 ? {
        ...res.checkHeader,
        subTotalAmount: +(res.checkHeader.itemAmount),
        totalAmount: +(res.checkHeader.itemAmount + res.checkHeader.taxAmount + serviceCharge - discount)
      } : {
        ...res.checkHeader,
        subTotalAmount: +(res.checkHeader.totalAmount),
        totalAmount: +(res.checkHeader.totalAmount - discount)
      };
      setPaymentCheck({ ...updatedResponse });
      setTableData(paymentCheck);
      setAuthResponse(res).then(() => {
        setPaymentType(9);
        setShowPayment({
          showTips: false,
          showReceiptCard: true,
          showReceipt: true,
          showSurvey: false
        });
      });
    }).catch((err) => {
      setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const handleProcessCreditError = (errMsg) => {
    disableFooter(true);
    if (tableData) {
      const authResponse = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')), 0);
      const tipAmt = getObjectValue(() => Number(JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips).toFixed(2), 0);
      const dataToSend = {
        message: errMsg,
        storeId: deviceInfo.storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
        checkHeaderId: tableData.id,
        ticketId: authResponse.ticket?.id,
        subtotalAmount: getObjectValue(() => authResponse.ticket?.subtotalAmount || authResponse.ticket?.subTotalAmount, 0),
        taxAmount: authResponse.ticket?.taxAmount,
        authAmount: 0,
        tipAmount: tipAmt,
        cardHolderName: null,
        redactedCardNumber: null,
        cardExpirationDate: null,
        cardType: null,
        uniqueCardIdentifier: null,
        transactionId: null,
        clientTransactionId: null,
        authorizationCode: null,
        paymentStageId: getObjectValue(() => paymentCheck.paymentStageId, null),
        employeeCard: null,
        isPreAuth: false,
        partialAuth: false,
        serviceChargeAmount: getObjectValue(() => authResponse?.ticket?.serviceChargeAmount, 0),
        discountAmount: getObjectValue(() => authResponse?.ticket?.discountAmount, 0),
      };
      setErrorMessage(errMsg);
      paymentAuthError(dataToSend).then(() => {
        clearAuthResponse();
        setOpen(false);
        setShowPayment({
          showTips: false,
          showReceiptCard: true,
          showReceipt: false,
          showSurvey: false,
          showError: true,
          ingenico: false
        });
        setPaymentType(9);
        disableFooter(true);
        enableStartOverBtn(true);
        setShowRetryMessage(true);
      });
    }
  };

  const handleFailureRoute = (err) => {
    handleProcessCreditError(err.message);
  };

  const completeProcessSale = (response) => {
    disableFooter(true);
    const authResponse = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')), 0);
    if (authResponse) {
      const aAmt = (response.authorizedAmount / 100).toFixed(2);
      const tipAmt = getObjectValue(() => Number(JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips).toFixed(2), 0);
      const dataToSend = {
        ...response,
        message: '',
        storeId: deviceInfo.storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
        checkHeaderId: tableData.id,
        ticketId: authResponse.ticket?.id,
        subtotalAmount: getObjectValue(() => authResponse.ticket?.subtotalAmount || authResponse.ticket?.subTotalAmount, 0),
        taxAmount: authResponse.ticket?.taxAmount,
        authAmount: aAmt,
        tipAmount: tipAmt,
        cardHolderName: response.cardholderName,
        redactedCardNumber: response.redactedCardNumber,
        cardExpirationDate: response.cardExpirationDate,
        cardType: response.cardType,
        uniqueCardIdentifier: response.uniqueCardIdentifier,
        transactionId: response.transactionId,
        clientTransactionId: response.clientTransactionId,
        authorizationCode: response.authCode,
        paymentStageId: getObjectValue(() => paymentCheck.paymentStageId, null),
        employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
        isPreAuth: false,
        partialAuth: false,
        serviceChargeAmount: getObjectValue(() => authResponse?.ticket?.serviceChargeAmount, 0),
        discountAmount: getObjectValue(() => authResponse?.ticket?.discountAmount, 0),
        sendOrder: true
      };
      setPaymentType(9);
      setShowPayment({
        ...showPayment,
        showPay: false,
        showReceiptCard: true
      });
      paymentSale(dataToSend).then((res) => {
        updateSeatInfo(res.checkHeader);
        setOpen(false);
        setTileImage(getObjectValue(() => kioskTile.filter((e) => e.tileTarget.receiptPage), []));
        window.sessionStorage.setItem('authResponse', JSON.stringify(res));
        window.sessionStorage.removeItem('tipAmt');
        window.sessionStorage.removeItem('payAmt');
        setTableData(res.checkHeader);
        setShowPayment({
          ...showPayment,
          showTips: false,
          showReceiptCard: true,
          showPay: false,
          showReceipt: true,
          showSurvey: false,
          ingenico: false
        });
        if (supportsSurvey) {
          getSurveyResponse();
          setPaymentType(10);
        }
      }).catch((err) => {
        enableStartOverBtn(true);
        setTileImage(getObjectValue(() => kioskTile.filter((e) => e.tileTarget.paymentPage), []));
        paymentAuthError({ ...dataToSend, message: err.message }).then(() => {
          setPaymentType(9);
          setShowPayment({
            showTips: false,
            showReceiptCard: true,
            showPay: false,
            ingenico: false,
            showError: true,
            hideBtn: false,
            showReceipt: false,
            showSurvey: false
          });
        });
      });
    }
  };

  const processSaleInit = (saleResponse) => {
    const Amount = +(saleResponse.ticket?.totalAmount * 100);
    const TipAmount = +(tipAmount * 100);
    const data = {
      type: 'processCreditSale',
      data: {
        merchantInvoiceId: saleResponse.ticket?.id.toString(),
        employeeId: saleResponse.checkHeader.employeeId.toString(),
        latitude: '0',
        longitude: '0',
        notes: '',
        referenceId: saleResponse.ticket?.id.toString() || saleResponse.ticket?.referenceId,
        amount: `${Number(Amount).toFixed()}`,
        tipAmount: `${Number(TipAmount).toFixed()}`
      },
    };
    if (window.ReactNativeWebView) {
      setShowPayment({
        showTips: false,
        showReceiptCard: true,
        showPay: true,
        hideBtn: false,
        showReceipt: false,
        showError: false
      });
      disableFooter(false);
      EventEmitter.sendMessage(data, (res) => {
      }, (err) => {
        console.log(err);
      });
    }
  };

  const ingenicoIPP350Payment = (saleResponse) => {
    const Amount = +(saleResponse.ticket?.totalAmount * 100);
    const TipAmount = +(tipAmount * 100);
    const dataToSend = {
      storeId: deviceInfo.storeId,
      deviceId: deviceInfo.deviceId,
      checkHeaderId: tableData.id,
      ticketId: saleResponse.ticket?.id.toString(),
      totalAmount: +(Amount).toFixed(2),
      tipAmount: +(TipAmount).toFixed(2)
    };
    ingenicoPayment(dataToSend).then((response) => {
      completeProcessSale(response);
    }).catch((error) => {
      handleProcessCreditError(error.message);
    });
  };

  const ingenicoPay = (val) => {
    isSetHideContinueBtn(true);
    enableStartOverBtn(false);
    ingenicoIPP350Payment(val);
  };

  const handleCreditCard = () => {
    setOpen(true);
    const subTotalAmount = Number(tableData.subTotalAmount).toFixed(2);
    const taxAmount = Number(tableData.taxAmount).toFixed(2);
    const dataToSend = {
      storeId: deviceInfo.storeId,
      deviceId: deviceInfo.deviceId,
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      checkHeaderId: tableData.id,
      employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
      ticketSplitTypeId: 2,
      splitValue: 1,
      paymentStageId: getObjectValue(() => paymentCheck.paymentStageId, null),
      subTotalAmount,
      taxAmount,
      totalAmount: Number(tableData.totalAmount).toFixed(2),
      unpaidAmount: Number(tableData.unpaidAmount).toFixed(2),
      seatIds: [],
      serviceChargeAmount: Number(tableData.serviceChargeAmount).toFixed(2),
      discountAmount: Number(tableData.discountAmount).toFixed(2),
      sendOrder: true
    };
    paymentInitialization(dataToSend).then((val) => {
      disableFooter(false);
      setAuthResponse(val).then(() => {
        if (window.ReactNativeWebView && getObjectValue(() => auth.cardReaderType !== 3 && auth.cardReaderType !== 5 && auth.cardReaderType !== 6 && auth.cardReaderType !== 4 && auth.cardReaderType !== 7 && auth.cardReaderType !== 8, false)) {
          EventEmitter.removeListeners('processPayment', () => {});
          EventEmitter.removeListeners('processCreditSale', () => {});
          processSaleInit(val);
          enableStartOverBtn(false);
        } else if (getObjectValue(() => auth.cardReaderType === 3 || auth.cardReaderType === 4 || auth.cardReaderType === 5 || auth.cardReaderType === 6 || auth.cardReaderType === 7 || auth.cardReaderType === 8, false)) {
          ingenicoPay(val);
        }
      });
    }).catch((err) => {
      disableFooter(true);
      enableStartOverBtn(true);
      setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const callVoid = () => {
    const currentCheck = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat')), []);
    const dataToSend = {
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      storeId: deviceInfo.storeId,
      checkHeaderId: currentCheck?.id,
      deviceId: deviceInfo.deviceId,
    };
    if (currentCheck?.open) {
      checkVoid(dataToSend);
    }
    goToLandingPage();
  };

  const startQrPaymentTimer = (value) => {
    setOpen(true);
    let val = value;
    if (qrTimerId.current) {
      clearInterval(qrTimerId.current);
    }
    let check;
    qrTimerId.current = setInterval(() => {
      if (val > 0) {
        val -= 1;
        setCounter(val);
        if (val === 20) {
          setCancelOrderPopUp(true);
        }
        document.addEventListener('getUpdatedCheck', (a) => {
          if (a?.detail?.id === check?.id) {
            check = a.detail;
          }
          document.removeEventListener('getUpdatedCheck', () => {});
        });
        if (check?.unpaidAmount === 0) {
          setPaymentType(9);
          setShowPayment({
            ...showPayment,
            showTips: false,
            showReceiptCard: true,
            showPay: false,
            showInitial: false,
            qrCode: false,
            qrConfirm: false,
            showReceipt: true,
            showSurvey: false,
            ingenico: false
          });
          disableFooter(true);
          clearTimeout(qrTimerId.current);
        }
      } else if (val === 0) {
        callVoid();
        disableFooter(true);
        setCancelOrderPopUp(false);
        clearInterval(qrTimerId.current);
        setOpen(false);
      } else {
        clearInterval(qrTimerId.current);
      }
    }, [1000]);
  };

  const scanPaymentInit = () => {
    setOpen(true);
    const subTotalAmount = Number(tableData.subTotalAmount).toFixed(2);
    const taxAmount = Number(tableData.taxAmount).toFixed(2);
    const dataToSend = {
      storeId: deviceInfo.storeId,
      deviceId: deviceInfo.deviceId,
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      checkHeaderId: tableData.id,
      employeeCard: null,
      ticketSplitTypeId: 2,
      splitValue: 1,
      paymentStageId: getObjectValue(() => paymentCheck.paymentStageId, null),
      subTotalAmount,
      taxAmount,
      totalAmount: Number(tableData.totalAmount).toFixed(2),
      unpaidAmount: Number(tableData.unpaidAmount).toFixed(2),
      seatIds: [],
      serviceChargeAmount: Number(tableData.serviceChargeAmount).toFixed(2),
      discountAmount: Number(tableData.discountAmount).toFixed(2),
      sendOrder: true
    };
    paymentInitialization(dataToSend).then((val) => {
      disableFooter(false);
      setAuthResponse(val).then(() => {
        setPaymentType(9);
        startQrPaymentTimer(120);
        setShowPayment({
          showTips: false,
          showReceiptCard: true,
          showPay: false,
          hideBtn: false,
          showReceipt: false,
          showInitial: false,
          qrCode: true
        });
      });
    }).catch((err) => {
      disableFooter(true);
      enableStartOverBtn(true);
      setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const handlePaymentInit = () => {
    disableFooter(true);
    enableStartOverBtn(true);
    setShowPayment({
      showTips: false,
      showReceiptCard: true,
      showPay: false,
      hideBtn: false,
      showReceipt: false,
      showInitial: false,
      ingenico: true
    });
  };

  const returnCreditCardMethod = () => {
    return getObjectValue(() => auth.cardReaderType === 3 || auth.cardReaderType === 4 || auth.cardReaderType === 5 || auth.cardReaderType === 6 || auth.cardReaderType === 7 || auth.cardReaderType === 8, false) ? handlePaymentInit() : handleCreditCard();
  };

  const handlePaymentTypes = (type) => {
    enableStartOverBtn(false);
    switch (type) {
      case 'cash': handleCashPayment(); break;
      case 'card': returnCreditCardMethod(); break;
      case 'scan': setPaymentType(9);
        setShowPayment({
          showTips: false,
          showReceiptCard: true,
          showPay: false,
          hideBtn: false,
          showReceipt: false,
          showInitial: false,
          qrConfirm: true
        }); break;
      case 'goBack': setPaymentType(8); enableStartOverBtn(false);
        setShowPayment({
          showTips: true,
          showReceiptCard: true,
          showPay: false,
          hideBtn: false,
          showReceipt: false
        }); enableStartOverBtn(true); break;
      default: returnCreditCardMethod();
        break;
    }
  };

  const handleTypes = () => {
    console.log('eeee', payType)
    switch (payType) {
      case 'all': setPaymentType(9);
        setShowPayment({
          showTips: false,
          showReceiptCard: true,
          showPay: false,
          hideBtn: false,
          showReceipt: false,
          showInitial: true,
          qrConfirm: false
        }); break;
      case 'payatcounter': setPaymentType(9);
      setShowPayment({
        showTips: false,
        showReceiptCard: true,
        showPay: false,
        hideBtn: false,
        showReceipt: false,
        showInitial: false,
        qrConfirm: false,
        showpayatcounter: true
      }); break;
      case 'cash': handleCashPayment(); break;
      case 'card': returnCreditCardMethod(); break;
      case 'scan': setPaymentType(9);
        setShowPayment({
          showTips: false,
          showReceiptCard: true,
          showPay: false,
          hideBtn: false,
          showReceipt: false,
          showInitial: false,
          qrConfirm: true
        }); break;
      default: returnCreditCardMethod();
        break;
    }
  };

  const tipRule = () => {
    return (active.length > 0 ? true : active > 0);
  };

  const tipMandate = () => {
    return isTipRequried ? tipRule() : true;
  };

  const orderMoreItems = () => {
    props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/orders`);
  };

  const handleCheck = (type) => {
    if (tipMandate()) {
      switch (type) {
        case 'tips': setPaymentType(9);
          enableStartOverBtn(true);
          setShowPayment({
            showTips: false,
            showReceiptCard: true,
            showPay: false,
            hideBtn: false,
            showReceipt: false
          });
          window.sessionStorage.setItem('tipAmt', JSON.stringify({ totalTips: tipAmount, unpaidTips: tipAmount, paidTips: 0 }));
          if (payType === 'all') {
            setPaymentType(9); setShowPayment({
              showTips: false,
              showReceiptCard: true,
              showPay: false,
              hideBtn: false,
              showReceipt: false,
              showInitial: true
            });
          } else {
            handleTypes();
          }
          break;
        case 'qrPayRoute': setPaymentType(5); break;
        default: setPaymentType(6); break;
      }
    } else {
      setNotification({
        type: 'danger',
        message: 'Please Select tips',
      });
    }
  };

  const btnName = () => {
    switch (payType) {
      case 'cash': return LABEL().PAY_WITH_CASH;
      case 'card': return LABEL().PAY_WITH_CARD;
      case 'scanToPay': return LABEL().SCAN_TO_PAY;
      default: return LABEL().CONTINUE_WITH_PAYMENT;
    }
  };

  const handleRetry = () => {
    setErrorMessage('');
    setShowRetryMessage(false);
    if (window.ReactNativeWebView && getObjectValue(() => auth.cardReaderType !== 3 && auth.cardReaderType !== 4 && auth.cardReaderType !== 5 && auth.cardReaderType !== 6 && auth.cardReaderType !== 7 && auth.cardReaderType !== 8, false)) {
      setPaymentType(9);
    } else if (getObjectValue(() => auth.cardReaderType === 3 || auth.cardReaderType === 4 || auth.cardReaderType === 5 || auth.cardReaderType === 6 || auth.cardReaderType === 7 || auth.cardReaderType === 8, false)) {
      setShowPayment({
        showTips: false,
        showReceiptCard: true,
        showPay: false,
        hideBtn: false,
        showReceipt: false,
        ingenico: true
      });
      isSetHideContinueBtn(false);
    }
    disableFooter(false);
    enableStartOverBtn(false);
    returnCreditCardMethod();
  };

  const submitReceipt = (data, notificationCheck) => {
    const dataToSend = {
      storeId: deviceInfo.storeId,
      ticketId: authResponse && authResponse.ticket?.id ? authResponse.ticket?.id : null,
      deviceId: deviceInfo.deviceId,
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      emailAddress: receiptType.key === 'email' ? data : '',
      countryCode,
      phoneNumber: receiptType.key === 'text' ? data : '',
      optIn: false,
      employeeCard: null,
      notification: notificationCheck || false
    };
    if (receiptType.key === 'text') {
      receiptSms(dataToSend).then(() => {
        window.sessionStorage.removeItem('inputs');
        setPaymentType(5);
        startTimer(5);
      }).catch((err) => {
        setReceiptType({
          head: CUSTOM_MESSAGES().RECEIPT_PHONE_NUMBER,
          name: LABEL().EMAIL,
          key: 'text',
          maxlength: phoneNumberMaxLength
        });
        setNotification({
          type: 'danger',
          message: err.message
        });
      });
    } else {
      receiptEmail(dataToSend).then(() => {
        window.sessionStorage.removeItem('inputs');
        setPaymentType(5);
        startTimer(5);
      }).catch((err) => {
        setReceiptType({
          head: CUSTOM_MESSAGES().RECEIPT_EMAIL,
          name: LABEL().TEXT,
          key: 'email',
          maxlength: 256
        });
        setNotification({
          type: 'danger',
          message: err.message
        });
      });
    }
  };

  const renderBack = () => {
    const backObj = [4].includes(paymentType) && {
      backBtn: true
    };
    return backObj;
  };

  const handleReceipt = (type) => {
    switch (type) {
      case 'text': setReceiptType({
        head: CUSTOM_MESSAGES().RECEIPT_PHONE_NUMBER,
        name: LABEL().EMAIL,
        key: type,
        maxlength: phoneNumberMaxLength
      }); setShowPayment({
          showPay: false, hideBtn: false, showReceiptCard: true, showReceipt: false, showReceiptType: true
        }); break;
      case 'email': setReceiptType({
        head: CUSTOM_MESSAGES().RECEIPT_EMAIL,
        name: LABEL().TEXT,
        key: type,
        maxlength: 256
      }); setShowPayment({
          showPay: false, hideBtn: false, showReceiptCard: true, showReceipt: false, showReceiptType: true
        }); break;

      default: startTimer(5); setPaymentType(5); break;
    }
  };
  const handleKeyboardValue = (data) => {
    setKeyboardValue(data);
  };

  const handleReceiptBack = () => {
    window.sessionStorage.removeItem('inputs');
    setShowPayment({
      showTips: false,
      showReceiptCard: true,
      showReceipt: true,
      showSurvey: false
    });
  };

  const goToCart = () => {
    props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/cart`);
  };

  const continueFireApi = () => {
    const seat = JSON.parse(window.sessionStorage.getItem('seat'))
    console.log('eeeee', seat)
    const datatosend = {
      storeId: props?.deviceInfo?.storeId,
      deviceId: props?.deviceInfo?.deviceId,
      employeeId: props?.userInfo?.id,
      checkHeaderId: seat?.id,
      employeeCard: props?.userInfo?.employeeCard,
      items: seat.PendingItems.map((item) => {
        return {
          checkOrderItemId: item.id
        };
      })
    };
    sendChecks(datatosend).then((res) => {
      enableStartOverBtn(false)
      updateChecksAfterResponse(res);
      setPaymentType(5);
      startTimer(5)
    }).catch((err) => {
      setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  // HTML CSS Code

  return (
    <div className="h-100">
      {props.loading && <Loader />}
      {renderBack().backBtn
        && (<div className="position-absolute text-primary od-text-primary fs-18" style={{ left: '5px', top: 0, zIndex: '999' }}><i role="presentation" className="fa fa-chevron-left" aria-hidden="true" onClick={() => setPaymentType(3)} /></div>)}
      <KioskPaymentScreens
        loading = {props.loading2}
        handlePaymentTypes={handlePaymentTypes}
        currencySymbol={LABEL().CURRENCY_SYMBOL}
        ingenicoPay={ingenicoPay}
        btnName={btnName()}
        payType={payType}
        check={check}
        deviceInfo={deviceInfo}
        goToLandingPage={goToLandingPage}
        isHeight={isHeight}
        handleReceiptBack={handleReceiptBack}
        isHideContinueBtn={isHideContinueBtn}
        themeProperties={themeProperties}
        authResponse={authResponse}
        handleSurveySubmit={handleSurveySubmit}
        tipsList={tipsList}
        surveyData={surveyData}
        showPayment={showPayment}
        tableData={tableData}
        handleKeyboardValue={handleKeyboardValue}
        keyboardValue={keyboardValue}
        totalAmountForTip={getTotalAmountForTip()}
        handleButtonClick={handleButtonClick}
        tipAmount={tipAmount}
        active={active}
        count={count}
        goToCart={goToCart}
        continueFireApi={continueFireApi}
        handleRetry={handleRetry}
        countryCode={countryCode}
        handleCountryCodeChange={handleCountryCodeChange}
        paymentType={paymentType}
        paymentCallBack={completeProcessSale}
        handleCheck={handleCheck}
        submitReceipt={submitReceipt}
        errorMessage={errorMessage}
        goToOrder={goToOrder}
        handleFailureRoute={handleFailureRoute}
        handleCashPayment={handleCashPayment}
        handleCreditCard={handleCreditCard}
        goToReceipt={goToReceipt}
        orderMoreItems={orderMoreItems}
        receiptType={receiptType}
        handleReceipt={handleReceipt}
        tileImage={tileImage}
        setInActivityStatus={setInActivityStatus}
        showRetryMessage={showRetryMessage}
        setCounter={setCounter}
        counter={counter}
        setOpen={setOpen}
        inActivityStatus={inActivityStatus}
        handleTypes={handleTypes}
        scanPaymentInit={scanPaymentInit}
      />
      <Modal
        isOpen={showPayment.isNumberKeyboardOpen}
        isModalCenter
        noBackground
        loading={props.loading}
        customClass2={style.maxWidth}
      >
        <div className="m-3 h-100 justify-content-center align-items-center text-center position-relative">
          <div className="h-80">
            <div className="text-center col-12 p-0">
              <div className="w-100 h-100 position-relative">
                <div className="col-12 text-center p-0 h-85">
                  <NumberKeyboard
                    name="tipsAmount"
                    haveCurrency={
                active === `${LABEL().KIOSK_CUSTOM_AMOUNT} ${LABEL().CURRENCY_SYMBOL}` ? `${LABEL().CURRENCY_SYMBOL}` : '%'
              }
                    type="withoutDone"
                    isDotRequired
                    isOpen={showPayment.isNumberKeyboardOpen}
                    value={active === `${LABEL().ROUND_UP}` ? '' : keyboardValue}
                    onChange={(e) => {
                      handleKeyboardValue(e);
                      if ([`${LABEL().KIOSK_CUSTOM_AMOUNT} ${LABEL().CURRENCY_SYMBOL}`].includes(active)) {
                        handleButtonClick(active, e);
                      } else {
                        handleButtonClick(`${LABEL().KIOSK_CUSTOM_PERCENT} %`, e);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="h-20">
            <div className="col-12 d-flex p-0">
              <div className="col-12 text-center p-0">
                <button className="btn btn100 btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 w-100 fs-20" type="button" onClick={() => setShowPayment({ ...showPayment, isNumberKeyboardOpen: false })}>
                  <div className="fs-30">{LABEL().KIOSK_CLOSE}</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {cancelOrderPopUp && (
        <Modal
          isOpen={cancelOrderPopUp}
          isModalCenter
          noBackground
          loading={props.loading}
          customClass2={style.maxWidth}
        >
          <div className="m-3 h-100 justify-content-center align-items-center text-center position-relative">
            <div className="h-80">
              <div className="fw-600 text-center fs-26">
                {CUSTOM_MESSAGES().YOUR_ORDER_WILL_CANCELLED}
              </div>
              <div className="fw-600 text-center fs-26">
                {counter}
              </div>
            </div>
            <div className="h-20">
              <div className="col-12 d-flex p-0">
                <div className="col-6">
                  <button className="w-100 btn btn100 btn-secondary od-btn-secondary" type="button" onClick={() => { setCancelOrderPopUp(false); callVoid(); }}>
                    <div className="fs-18">{LABEL().CANCEL_ORDER}</div>
                  </button>
                </div>
                <div className="col-6 text-center p-0">
                  <button className="btn btn100 btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 w-100 fs-20" type="button" onClick={() => { setCancelOrderPopUp(false); setCounter(60); startQrPaymentTimer(60); }}>
                    <div className="fs-18">{LABEL().STAY}</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

// Redux Part

const mapStateToProps = ({
  orders,
  oauth,
  payment,
  survey,
  theme,
  kiosk,
  storeChecks,
}) => ({
  cart: orders.cart,
  check: orders.seats,
  auth: oauth.authInfo,
  paymentCheck: orders.paymentCheck,
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  surveyData: survey.surveyData,
  loading: survey.loading || payment.loading,
  loading2: storeChecks.loading,
  authResponse: payment.authResponse,
  themeProperties: theme.themeProperties,
  isHeight: orders.isHeight,
  kioskTile: kiosk.kioskTile,
  inActivityStatus: oauth.inActivityStatus,
  countrycode: orders.countrycode,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setPaymentCheck,
  setIsAssisstance,
  clearCart,
  disableFooter,
  sendChecks,
  updateChecksAfterResponse,
  ingenicoPayment,
  paymentSale,
  enableStartOverBtn,
  removeSeat,
  paymentCash,
  receiptSms,
  getSurvey,
  submitSurvey,
  paymentSignature,
  receiptEmail,
  setNotification,
  setAuthResponse,
  paymentAuthError,
  paymentInitialization,
  clearAuthResponse,
  setOpen,
  setInActivityStatus,
  updateSeatInfo,
  setScreenSaverStatus,
  checkVoid
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(KioskPayment);
